export default {
    DIVIDER: 'divider',
    MENU_ITEM: 'menu-item',
};
